<template>
    <div class="flex w-full flex-col flex-wrap gap-4 rounded-b-md bg-gray-100 p-6 text-black sm:flex-row md:flex-nowrap">
        <div class="flex flex-col justify-between gap-2">
            <span class="text-base lg:text-lg/none">{{ $t('cart.total') }}</span>
            <div class="flex flex-col">
                <template v-if="cartDebugMode">
                    <span
                        class="text-xl font-bold tabular-nums sm:text-2xl lg:text-2xl/none"
                        :class="cart().getCartTotalPriceLocal !== cart().getCartTotalPriceValidated ? 'text-red-500' : 'text-green-500'"
                    >
                        {{ cartDebugMode ? 'CL: ' : '' }}{{ cart().hasCartProducts ? currencyFormat(cart().getCartTotalPriceLocal) : currencyFormat(0) }}
                    </span>
                    <span
                        class="text-xl font-bold tabular-nums sm:text-2xl lg:text-2xl/none"
                        :class="cart().getCartTotalPriceLocal !== cart().getCartTotalPriceValidated ? 'text-red-500' : 'text-green-500'"
                    >
                        CS: {{ cart().hasCartProducts ? currencyFormat(cart().getCartTotalPriceValidated) : currencyFormat(0) }}
                    </span>
                </template>
                <template v-else>
                    <span
                        class="text-xl font-bold tabular-nums leading-none lg:text-2xl/none"
                    >
                        {{ cart().hasCartProducts ? currencyFormat(cart().getCartTotalPriceValidated || cart().getCartTotalPriceLocal) : currencyFormat(0) }}
                    </span>
                </template>
            </div>
        </div>
        <div class="grow lg:overflow-hidden">
            <FormKit
                type="submit"
                :classes="{
                    outer: isCheckoutPath(route.path) ? 'lg:hidden' : '',
                    input: 'gap-2 items-center'
                }"
                :disabled="isCheckoutDisabled() || disabled"
            >
                <template #prefixIcon>
                    <Icon :icon="IconShoppingCart" class=" text-2xl lg:text-xl" />
                </template>
                <span class="text-base">
                    {{ $t('cart.checkout') }}
                </span>
            </FormKit>
        </div>
    </div>
</template>

<script setup lang="ts">
    import IconShoppingCart from '@/assets/icons/shopping-cart.svg'
    import Icon from '~/components/Icon.vue'
    import { cart } from '~/store/cart'
    import { isCheckoutPath } from '~/utils/path-utils'
    defineProps(
        {
            disabled: {
                type: Boolean,
                default: false
            }
        }
    )
    const { public: { cartDebugMode } } = useRuntimeConfig()
    const route = useRoute()
</script>
